import React from "react";
import type { useToken } from "./useToken";

export const AuthContext = React.createContext<ReturnType<typeof useToken>>(
	{} as any,
);

export type AuthConfig = {
	guestIsEnabled: boolean;
	useEmailAndPassword: boolean;
	useAzureAD: boolean;
	useWindowsAuth: boolean;
	AzureConfig: AzureConfig;
};

export type AzureConfig = {
	clientId: string;
	authority: string;
	redirectUri: string;
};
